import { Box, Loader } from 'braid-design-system';
import type { FC } from 'react';

import { JobStatDetailLayout } from 'src/components/app/JobSection/JobStatDetail';
import { JobSectionLayout } from 'src/components/app/JobSectionLayout';
import { TextSkeleton } from 'src/libs/TextSkeleton';

import { AppPageLayout } from './AppPageLayout';

export const CandidateManagementAppSkeleton: FC = () => (
  <AppPageLayout
    mobileStickyHeader={null}
    jobSection={{
      boxShadow: 'small',
      element: (
        <JobSectionLayout
          heading={<TextSkeleton height="large" width="20%" />}
          details={
            <JobStatDetailLayout
              expireDate={<TextSkeleton height="small" width="7%" />}
              totalApplications={<TextSkeleton height="small" width="10%" />}
              billableApplicants={null}
            />
          }
          alert={null}
          jobAction={null}
          freemiumButton={null}
          modals={null}
        />
      ),
    }}
    content={
      <Box
        background="surface"
        paddingX={['gutter', 'xxlarge', 'xxxlarge']}
        paddingY={['large', 'xlarge']}
        display="flex"
        justifyContent="center"
        alignItems="center"
        data={{ testid: 'app-loader' }}
      >
        <Loader />
      </Box>
    }
    pageTabs={null}
    mobileFilterSection={null}
  />
);
